export const VALID_CACHE_KEY_MAP = {
  CONTRIBUTORS: "contributors",
  GLOBAL_NAV: "globalNav",
  JOBS: "jobs",
  PAGE_DATA_MAP: "pageDataMap",
  SITEMAP: "sitemap"
};

export const VALID_CACHE_KEYS = Object.values(VALID_CACHE_KEY_MAP);

export const CACHE_DIRECTORY = "tmp";
export const BUILD_DIRECTORY = "build";

export const ITEM_PREVIEW_LIST_FORMS = {
  Story2: "Story 2",
  Story3: "Story 3",
  Story3FeatureImageLeft: "Story 3 featured: full-width left",
  Story3FeatureImageRight: "Story 3 featured: full-width right",
  Story3FeatureTwoThirds: "Story 3 featured: two-thirds",
  Story3FeatureHalf: "Story 3 featured: half",
  Link2: "Link 2",
  Link2Feature: "Link 2 featured",
  Link3: "Link 3",
  Link4: "Link 4",
  Link4TitleOnly: "Link 4 title only",
  Avatar4: "Avatar 4",
  Avatar6: "Avatar 6",

  // special purpose
  Headline: "Headline"
};

export const FEATURED_IMAGES_POSITIONS = {
  Top: "top",
  Left: "left",
  Right: "right"
};

export const PRIVACY_MANDATE_REGIONS = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "EL",
  "GG",
  "HU",
  "IE",
  "IS",
  "IT",
  "LI",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "UK",
  "US-CA",
  "US-CO",
  "US-DE",
  "US-OR"
];

export const BANNER_COOKIE_NAME = "of_banner";

export const REQUIRED_COOKIES = [
  "_of", //TODO: Remove this once we retire in-house cookie banner
  "OptanonConsent", //Accepted or rejected cookies
  "OptanonAlertBoxClosed", //Tracks when and if the Optanon alert box has been dismissed
  BANNER_COOKIE_NAME, // whether banner has been dismissed
  "__stripe_mid", //new fundraise up cookie 9/23
  "fundraiseup_session", // Fundraise Up required
  "fundraiseup_cid", // Fundrasise Up required
  "ASLBSA", // Azure Front door
  "ASLBSACORS" // Azure Front door
];

export const BREAK_POINTS = {
  sm: 320,
  md: 680,
  lg: 1200
};

export const INTEGRATION_API = {
  baseUrl: import.meta.env?.VITE_INTEGRATION_API_URL,
  endpoints: {
    createEventLead: "/api/infor/create-event-lead",
    webToCase: "/api/salesforce/web-to-case"
  }
};

export const SALESFORCE_CONSTANTS = {
  customHandlerEndpoint: "https://cloud.email.obama.org/signup-autocompleteV2",
  fieldNames: {
    orgId: "00N1R00000TOZ8p",
    campaignId: "00N1R00000TOZ8p",
    contentPreferences: "00NRm00000E8XOX",
    contactSourceUrl: "00N3600000RtkFX",
    subject: "subject",
    firstName: "00N3600000Rdh4s",
    lastName: "00N3600000Rdh4x",
    email: "email",
    phone: "phone",
    description: "description",
    redirectUrl: "retURL"
  }
};

export const VIRTUAL_SUPPORTERS_WALL_URL = ["supporter-wall/", "supporter-wall-sustainers/"];
